import { useEffect, useState } from "react";
import { X, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { FILTERS, PORTFOLIO } from "../data/content";

export const Work = () => {
  const [filter, setFilter] = useState("all");
  const [lightbox, setLightbox] = useState(null);

  const visible = filter === "all" ? PORTFOLIO : PORTFOLIO.filter((i) => i.cat === filter);

  useEffect(() => {
    if (!lightbox) return;
    const onKey = (e) => e.key === "Escape" && setLightbox(null);
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [lightbox]);

  return (
    <section className="section" id="work" data-testid="work-section">
      <div className="wrap">
        <Reveal className="section-head">
          <span className="eyebrow"><span className="sq" /> Our Work</span>
          <h2 data-testid="work-heading">A curated selection of what we've built.</h2>
          <p>Showcasing every project would be impossible — here's a look across social, print, branding,
            merchandise, pitch decks, illustration, events and more.</p>
        </Reveal>

        <Reveal delay={60}>
          <div className="filter-row" data-testid="work-filters">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                className={`filter-btn ${filter === f.key ? "active" : ""}`}
                onClick={() => setFilter(f.key)}
                data-testid={`filter-${f.key}`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="gallery" data-testid="work-gallery" key={filter}>
          {visible.map((it, i) => (
            <button
              className="gallery-item"
              key={it.src}
              style={{ animationDelay: `${Math.min(i * 45, 630)}ms` }}
              onClick={() => setLightbox(it)}
              data-testid={`gallery-item-${it.src.split("/").pop().replace(".jpg", "")}`}
              aria-label={`Open ${it.alt}`}
            >
              <span className="tag">{it.tag}</span>
              <img src={it.src} alt={it.alt} loading="lazy" width="1920" height="1080" />
              <span className="gallery-overlay" aria-hidden="true">
                <span className="g-title">{it.alt}</span>
                <span className="g-view">View <ArrowUpRight size={14} /></span>
              </span>
            </button>
          ))}
        </div>
      </div>

      {lightbox && (
        <div className="lightbox" onClick={() => setLightbox(null)} data-testid="lightbox" role="dialog" aria-modal="true">
          <button className="lightbox-close" aria-label="Close" onClick={() => setLightbox(null)} data-testid="lightbox-close">
            <X size={26} />
          </button>
          <img src={lightbox.src} alt={lightbox.alt} onClick={(e) => e.stopPropagation()} data-testid="lightbox-image" />
          <p className="lightbox-caption">{lightbox.alt}</p>
        </div>
      )}
    </section>
  );
};
